"use strict";

exports.__esModule = true;
exports.tealiumFormatter = exports.processTagManagerQueueForTealium = void 0;

const formatForTealium = (dataLayer, event) => {
  return { ...utag_data,
    ...dataLayer,
    ...event,
    eventlabel: event.eventlabel,
    eventtype: event.eventtype,
    eventaction: event.eventaction
  };
};

const formatEcommerceProductViewForTealium = event => {
  const ids = [];
  const names = [];
  const brands = [];
  const variants = [];
  const categories = [];
  const lists = [];
  const prices = [];
  const positions = [];
  event.products.map(item => {
    ids.push(item.id), names.push(item.name), brands.push(item.brand), variants.push(item.variant), categories.push(item.category), lists.push(item.list), prices.push(item.price), positions.push(item.position);
  });
  return {
    type: event.type,
    tealium_event: event.event,
    product_impression_id: ids,
    product_impression_name: names,
    product_impression_brand: brands,
    product_impression_variant: variants,
    product_impression_category: categories,
    product_impression_list: lists,
    product_impression_price: prices,
    product_impression_position: positions
  };
};

const formatEcommerceProductClickForTealium = event => {
  const ids = [];
  const names = [];
  const brands = [];
  const categories = [];
  const prices = [];
  const positions = [];
  event.products.map(item => {
    ids.push(item.id), names.push(item.name), brands.push(item.brand), categories.push(item.category), prices.push(item.price), positions.push(item.position);
  });
  return {
    type: event.type,
    tealium_event: event.event,
    product_id: ids,
    product_name: names,
    product_brand: brands,
    product_category: categories,
    product_unit_price: prices,
    product_position: positions
  };
};

const formatEcommerceCheckoutForTealium = event => {
  const ids = [];
  const names = [];
  const brands = [];
  const categories = [];
  const prices = [];
  const quantities = [];
  const positions = [];
  event.products.map(item => {
    ids.push(item.id), names.push(item.name), brands.push(item.brand), categories.push(item.category), prices.push(item.price), quantities.push(item.quantity);
    positions.push(item.position);
  });
  return {
    type: event.type,
    tealium_event: event.event,
    product_id: ids,
    product_name: names,
    product_brand: brands,
    product_category: categories,
    product_unit_price: prices,
    product_quantity: quantities,
    product_position: positions,
    checkout_step: event.checkout_step
  };
};

const formatEcommerceCheckoutOptionForTealium = event => {
  return {
    type: event.type,
    tealium_event: event.event,
    checkout_step: event.checkout_step,
    checkout_option: event.checkout_option
  };
};

const formatEcommercePurchaseForTealium = event => {
  const ids = [];
  const names = [];
  const brands = [];
  const categories = [];
  const prices = [];
  const quantities = [];
  const positions = [];
  event.products.map(item => {
    ids.push(item.id), names.push(item.name), prices.push(item.price), brands.push(item.brand), categories.push(item.category), quantities.push(item.quantity), positions.push(item.position);
  });
  return {
    tealium_event: event.event,
    order_id: event.order_id,
    order_currency: event.order_currency,
    order_store: event.affiliation,
    order_total: event.revenue,
    order_subtotal: event.revenue,
    product_id: ids,
    product_name: names,
    product_brand: brands,
    product_category: categories,
    product_unit_price: prices,
    product_quantity: quantities,
    product_position: positions
  };
};

const tealiumFormatter = (dataLayer, genericEvent) => {
  let preparedMessage = formatForTealium(dataLayer, genericEvent);

  if (genericEvent.event === 'product_view') {
    preparedMessage = formatEcommerceProductViewForTealium(genericEvent);
  }

  if (genericEvent.event === 'product_click') {
    preparedMessage = formatEcommerceProductClickForTealium(genericEvent);
  }

  if (genericEvent.event === 'checkout') {
    preparedMessage = formatEcommerceCheckoutForTealium(genericEvent);
  }

  if (genericEvent.event === 'checkout_option') {
    preparedMessage = formatEcommerceCheckoutOptionForTealium(genericEvent);
  }

  if (genericEvent.event === 'purchase') {
    preparedMessage = formatEcommercePurchaseForTealium(genericEvent);
  }

  return preparedMessage;
};

exports.tealiumFormatter = tealiumFormatter;

const processTagManagerQueueForTealium = (tagManager, tagManagerQueue) => {
  if (tagManagerQueue.length > 0) {
    tagManagerQueue.map(event => event.type === 'pageview' ? tagManager.view({ ...utag_data
    }) : event.type === 'event' ? tagManager.link({ ...utag_data,
      eventlabel: event.eventlabel,
      eventtype: event.eventtype,
      eventaction: event.eventaction
    }) : () => {});
  }
};

exports.processTagManagerQueueForTealium = processTagManagerQueueForTealium;